import React from "react";
import {
  FaAmazon,
  FaGlobeAmericas,
  FaMobileAlt,
  FaStore,
  FaUtensils,
} from "react-icons/fa";
import { RewardProvider } from "../types/reward.entity";

type ProviderMeta = {
  label: string;
  icon: React.ReactNode;
  color: string;
  gradient: string;
};

export const rewardProviderMeta: Record<RewardProvider, ProviderMeta> = {
  AMAZON: {
    label: "Amazon",
    icon: <FaAmazon />,
    color: "text-amber-500",
    gradient: "from-amber-500 to-orange-500",
  },
  YAMANI_RESTURANT: {
    label: "Yamani Restaurant",
    icon: <FaUtensils />,
    color: "text-rose-500",
    gradient: "from-rose-500 to-red-500",
  },
  UPPER: {
    label: "Upper",
    icon: <FaMobileAlt />,
    color: "text-sky-500",
    gradient: "from-sky-500 to-blue-500",
  },
  TAALY: {
    label: "Taaly",
    icon: <FaStore />,
    color: "text-brand-500",
    gradient: "from-brand-400 to-brand-700",
  },
  TREMENDOUS: {
    label: "Tremendous",
    icon: <FaGlobeAmericas />,
    color: "text-fuchsia-600",
    gradient: "from-fuchsia-500 to-pink-500",
  },
};

export const getRewardProviderMeta = (providerName?: string) =>
  rewardProviderMeta[(providerName as RewardProvider) || "TAALY"] || rewardProviderMeta.TAALY;
